<div
  [ngClass]="{
    'is-selected': isShowCard && selectedValueControl.value === entity?.id,
    'is-desktop': isDesktop,
    'card card-step': isShowCard,
    'is-with-footer': isWithFooter
  }"
>
  <div *ngIf="!isOnlyEdit && !isDesktop" [ngClass]="{ 'card-header': isShowCard }">
    <app-radio-button
      [control]="selectedValueControl"
      [id]="entity?.id"
      [label]="label"
      [value]="entity?.id"
      [classGroup]="'not-mb'"
    ></app-radio-button>
  </div>
  <div [ngClass]="{ 'card-body': isShowCard }" *ngIf="selectedValueControl.value === entity?.id || isDesktop">
    <div [ngClass]="{ container: isShowCard }">
      <identifier-entity-update
        *ngIf="isShowIdentifier"
        [formGroup]="formGroup"
        [code]="entity?.entityCode"
        [type]="type"
        [errors]="errors"
        [identifierFieldName]="'entityIdentifier'"
        [identifierQualifierFieldName]="'entityIdentifierQualifier'"
        [needUpdateValidators]="true"
      ></identifier-entity-update>
      <!-- name -->
      <app-control-wrapper [control]="formGroup.get('name')" [errors]="errors.name" helper="FORM_LABEL.AS_IN_COMMERCIAL_INVOICE">
        <label for="name" control-label>{{ "LABELS.NAME" | translate }}</label>
        <app-search-wrapper control-wrapper [items]="entities" [loading]="companyLoading" (callback)="changeAddress($event)">
          <input
            type="text"
            [formControl]="formGroup.get('name')"
            class="form-control"
            id="name"
            name="name"
            [dropSpecialCharacters]="false"
            [patterns]="CUSTOM_MASK"
            [mask]="'F*'"
            [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
          />
        </app-search-wrapper>
      </app-control-wrapper>

      <!-- email -->
      <app-control-wrapper *ngIf="shouldShowEmail" [control]="formGroup.get('email')" [errors]="errors.email">
        <label control-label for="email">{{ "LABELS.EMAIL_ADDRESS" | translate }}</label>
        <input
          control-wrapper
          type="text"
          [formControl]="formGroup.get('email')"
          class="form-control"
          id="email"
          name="email"
          [dropSpecialCharacters]="false"
          [patterns]="CUSTOM_MASK"
          [mask]="'F{100}'"
          [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
          [maxMaskLength]="100"
        />
      </app-control-wrapper>

      <!-- phone -->
      <input-phone
        *ngIf="shouldShowPhone"
        [fc]="formGroup.get('phone')"
        [errors]="errors?.phone || errorsPhone"
        [label]="'LABELS.MOBILE_NUMBER'"
        [id]="'phone'"
      ></input-phone>

      <!-- fax -->
      <input-phone
        *ngIf="shouldShowFax"
        [fc]="formGroup.get('fax')"
        [errors]="errors?.fax || errorsPhone"
        [label]="'LABELS.FAX'"
        [id]="'fax'"
      ></input-phone>

      <!-- address -->
      <ng-container *ngIf="isShowAddress">
        <address-update
          [formGroup]="formGroup"
          [code]="entity?.entityCode"
          [errors]="errors"
          [isShowState]="isShowState"
          [isShowCountry]="isForeignImporter || isConsigneeEntity"
          [isDesktop]="isDesktop"
          [defaultCountry]="isConsigneeEntity ? 'US' : isForeignImporter ? null : defaultCountry"
          [isFilterRestrictedCountries]="code === enumEntityModelCode.IMPORTER"
        ></address-update>
      </ng-container>
    </div>
  </div>
</div>

<ng-content select="[entity-footer]"></ng-content>

<button type="button" class="btn btn-link btn-remove" *ngIf="isDesktop" (click)="resetForm()">
  <i class="fa fa-trash"></i>
  {{ "FORM_LABEL.CLEAR_FORM" | translate }}
</button>
